export default __webpack_public_path__ + "static/media/stroller.c5c5f8d1.png";